export function joinArray(arr1: any[], arr2: any[]) {
  return arr1.map(str => {
    return arr2.find(obj => {
      return obj.text === str
    })
  })
}
